import { makeStyles } from '@material-ui/core';

export const useEvaluationStyles = makeStyles(theme => ({
  autocomplete: {
    width: '100%',
  },
  formControl: {
    minWidth: 120,
  },
}));
